import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';
import classNames from 'classnames';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

const tooltipShowDelay = 350;
const SizeLegendIndicatorTooltip = <Tooltip id="SizeLegendIndicatorTooltip">Use for point sizes</Tooltip>;
const YAxisLegendIndicatorTooltip = (
    <Tooltip id="YAxisLegendIndicatorTooltip">Log-scale y-axis</Tooltip>
);
const IconLegendIndicatorTooltip = <Tooltip id="IconLegendIndicatorTooltip">Reset icons</Tooltip>;

function SizeLegendIndicator({ sizeValue, ...props }) {
    return (<span>
            <OverlayTrigger
                placement="top"
                delayShow={tooltipShowDelay}
                trigger={['hover', 'focus']} // <-- do this so react bootstrap doesn't complain about accessibility
                overlay={SizeLegendIndicatorTooltip}>
                <Button 
                    className={`${styles['histogram-legend-pill']} ${styles[!sizeValue ? 'off' : 'on']}`} 
                    size="xsmall" {...props}>
                    <i
                        className={classNames({
                            fa: true,
                            'fa-dot-circle-o': true,
                            [styles['histogram-size-encoding-icon']]: true
                        })}
                    />
                    {/*Size*/}
                </Button>
            </OverlayTrigger>
        </span>);
}
SizeLegendIndicator.propTypes = {
    sizeValue: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
};

function YAxisLegendIndicator({ yAxisValue = 'none', ...props }) {
    return (<span>
            <OverlayTrigger
                placement="top"
                delayShow={tooltipShowDelay}
                overlay={YAxisLegendIndicatorTooltip}>
                <Button className={`${styles['histogram-legend-pill']} ${styles[yAxisValue === 'none' ? 'off' : 'on']}`} 
                    size="xsmall" {...props}>
                    <i
                        className={classNames({
                            fa: true,
                            'fa-signal': true,
                            [styles['histogram-size-encoding-icon']]: true                            
                        })}
                    />
                    {/*Y-Axis: {yAxisValue}*/}
                </Button>
            </OverlayTrigger>
        </span>
    );
}
YAxisLegendIndicator.propTypes = { yAxisValue: PropTypes.string };

function IconLegendIndicator({ iconValue, ...props }) {
    return !iconValue ? null : (
        <span>
            <OverlayTrigger
                placement="top"
                delayShow={tooltipShowDelay}
                overlay={IconLegendIndicatorTooltip}>
                <Button className={styles['histogram-legend-pill']} size="xsmall" {...props}>
                    <i
                        className={classNames({
                            fa: true,
                            'fa-map-pin': true,
                            [styles['histogram-size-encoding-icon']]: true
                        })}
                    />
                    {/*Icon*/}
                </Button>
            </OverlayTrigger>
        </span>
    );
}

export { SizeLegendIndicator, YAxisLegendIndicator, IconLegendIndicator };
